import { TargetMetricKey } from '@app/shared/models/contracts/enums/shared-enums';
import {
  FirstLastTranche,
  OpmFirstLastWaterfallDictionaryDto,
  OpmWaterfallConditionDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import { translationKeys } from '@locale/setupI18n';

export const INSTITUTIONAL_MOM_KEY: TargetMetricKey = 'InstitutionalMoM';
export const INSTITUTIONAL_IRR_KEY: TargetMetricKey = 'InstitutionalIRR';

export const METRIC_TRANSLATION_MAP: Record<string, translationKeys> = {
  InstitutionalIRR: '_IRR',
  InstitutionalMoM: '_MoM',
  TotalOrdinaryEquity: '_TotalOrdinaryEquity',
};

export const hasIrrOrMomHurdle = (conditions: OpmWaterfallConditionDto[]): boolean =>
  conditions.some(
    (condition) =>
      condition.metric === INSTITUTIONAL_IRR_KEY || condition.metric === INSTITUTIONAL_MOM_KEY
  );

export const hasOnlyOrdinaryEquityTranche = (
  tranches: Record<string, FirstLastTranche>
): boolean => {
  const trancheList = Object.values(tranches);
  return (
    trancheList.length > 0 && trancheList.every((tranche) => !hasIrrOrMomHurdle(tranche.conditions))
  );
};

export const getTrancheDictionary = (
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto,
  selectedYear: string,
  selectedInstrument: string,
  firstOrLastFive: 'first' | 'last'
): Dictionary<FirstLastTranche>[] =>
  Object.entries(opmWaterfall[selectedYear][firstOrLastFive]).map(
    ([key]) =>
      opmWaterfall[selectedYear][firstOrLastFive][key].instruments[selectedInstrument].tranches
  );
